import styled from 'styled-components'

/**
 * Styled div without which all margind go out of whack.
 * This seems to have been a fix for react-bootstrap's generated
 * margins/paddings within a `container>row>col` pattern
 */
export const StyledSubHeaderContainerWrapper = styled.div.attrs(props => ({
  id: props.id,
  className: 'animated fadeIn'
}))`
  --navHeight: ${props => props.palette('subheader.height.md')};
  --navLeftMargin: ${props => props.palette('subheader.marginLeft.md')};

  background: ${props => props.palette('subheader.backgroundColor.md')};

  .container,
  .device-nav-col {
    padding: 0;
  }

  @media (max-width: 1200px) {
    --navLeftMargin: ${props => props.palette('subheader.marginLeft.lg')};
  }

  @media (max-width: 991px) {
    --navLeftMargin: ${props => props.palette('subheader.marginLeft.md')};

    /** Allow the container width to set its defaults if no overrides are set */
    .container {
      width: ${props => props.palette('subheader.width.md')};
      padding: ${props => props.palette('subheader.padding.md')};
    }
  }

  @media (max-width: 767px) {
    --navLeftMargin: 0;
    --navHeight: ${props => props.palette('subheader.height.sm')};


    .container {
      padding: 0;
    }
  }

  @media (max-width: 576px) {
    --navLeftMargin: 0;
    --navHeight: ${props => props.palette('subheader.height.sm')};
  }
`

StyledSubHeaderContainerWrapper.displayName = 'StyledSubHeaderContainerWrapper'



// WEBPACK FOOTER //
// ./src/containers/SubHeader/styled/StyledSubHeaderContainerWrapper.js